import {createStore} from 'vuex';

export default createStore({
    state: {
        appVersion: '1.0',
        appShortName: 'CS',
        appLongName: 'Categorical Spending',
        lookupBaseUrl: '/reportweb/api/lookup/',
        loadingNewData: false,
        appData: {
            IRPInvestigator: null,
            IRPLabandBranchChiefs: null,
            IRPSeniorInvestigator: null
        },
        pieChartsData: null,
        barChartData: null,
        tableData: null,
        exportOptions: [
            {
                name: 'Export Data as Excel',
                value: 'xls'
            },
            {
                name: 'Export Data as CSV',
                value: 'csv'
            }
        ],
        selectedFilters: {},
        contentType: '',
    },
    getters: {
        appVersion: state => state.appVersion,
        appShortName: state => state.appShortName,
        appLongName: state => state.appLongName,
        loadingNewData: state => state.loadingNewData,
        exportOptions: state => state.exportOptions,
        appData: state => state.appData,
        pieChartsData: state => state.pieChartsData,
        barChartData: state => state.barChartData,
        tableData: state => state.tableData,
        lookupBaseUrl: state => state.lookupBaseUrl,
        selectedFilters: state => state.selectedFilters,
        contentType: state => state.contentType,
    },
    mutations: {
        setLoadingNewData (state, payload) {
            state.loadingNewData = payload;
        },
        setAppData (state, payload) {
            state.appData = payload;
        },
        setPieChartsData (state, payload) {
            state.pieChartsData = payload;
        },
        setBarChartData (state, payload) {
            state.barChartData = payload;
        },
        setTableData (state, payload) {
            state.tableData = payload;
        },
        setSelectedFilter (state, payload) {
            if (!state.selectedFilters[payload.type]) {
                state.selectedFilters[payload.type] = {};
            }
            state.selectedFilters[payload.type] = payload.data;
        },
        setContentType (state, payload) {
            state.contentType = payload;
        },
        clearSelectedFilters (state) {
            state.selectedFilters = {};
        },
    },
    actions: {
        setLoadingNewData ({ commit }, payload) {
            commit('setLoadingNewData', payload);
        },
        setAppData ({ commit }, payload) {
            commit('setAppData', payload);
        },
        setPieChartsData ({ commit }, payload) {
            commit('setPieChartsData', payload);
        },
        setBarChartData ({ commit }, payload) {
            commit('setBarChartData', payload);
        },
        setTableData ({ commit }, payload) {
            commit('setTableData', payload);
        },
        setSelectedFilter ({ commit }, payload) {
            commit('setSelectedFilter', payload);
        },
        setContentType ({ commit }, payload) {
            commit('setContentType', payload);
        },
        clearSelectedFilters ({ commit }, payload) {
            commit('clearSelectedFilters', payload);
        },
    }
});